module.exports = __webpack_public_path__ + "static/media/happy-new-yearwhite.61526e6e.svg";